import { Params } from "./data-structures";
import { Results, StoredResult, SavedSearchResult } from "./data";
import { getBoolean, getPrintableCharacters, isEmpty } from "../../scriptts/utilities";
import usaj_ga from '../Analytics/usaj-analytics'
import { setUserObject } from "../../scriptts/session/sessionmain";


export class API {
    private controller?: AbortController | undefined;
    private static instance: API;
    private loadingElement: HTMLElement | null;
    private constructor() {
        this.loadingElement = document.querySelector(".usajobs-search-results__loading");
    }      
    public static get current(): API {
        if (API.instance == null) {
            API.instance = new API();
        }
        return API.instance
    }

    Reset(): void {
        API.instance.controller = undefined;
    }

    GetResults(p: Params): Promise<Results> {        
        if (this.controller) {
            this.controller.abort("call aborted");
        }
        this.controller = new AbortController();
        if (this.loadingElement && !this.loadingElement.classList.contains('is-active')) {
            this.loadingElement.classList.add('is-active');
        }
        p.Keyword = p.Keyword !== undefined ? getPrintableCharacters(p.Keyword) : p.Keyword;
        p.LocationName = p.LocationName.map(location => getPrintableCharacters(location));
        return fetch('/Search/ExecuteSearch', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            cache: "no-cache",
            signal: this.controller.signal,
            body: JSON.stringify(p)
        }).then(response => {
            if (this.loadingElement) {
                this.loadingElement.classList.remove('is-active');
            }
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            return response.json() as Promise<Results>;
        }).then(data => {
            this.GALogSearch(p, data);
            return data;
        });
    }

    GetStoredResults(savedSearchID: number): Promise<StoredResult> {
        if (this.controller) {
            this.controller.abort;
        }
        this.controller = new AbortController();
        if (this.loadingElement && !this.loadingElement.classList.contains('is-active')) {
            this.loadingElement.classList.add('is-active');
        }
        return fetch('/Search/ExecuteStoredSearch?SavedSearchID=' + savedSearchID.toString(), {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            cache: "no-cache",
            signal: this.controller.signal
        }).then(response => {
            if (this.loadingElement) {
                this.loadingElement.classList.remove('is-active');
            }
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            return response.json() as Promise<StoredResult>;
        }).then(data => {
            this.GALogSearch((<Params>JSON.parse(data.SavedSearchParams)), data.SearchResult);
            return data;
        });
    }

    GALogSearch(p: Params, data: Results) {
        let userObject = JSON.parse(sessionStorage.getItem('userObject') ?? "");
        let isAutocomplete = getBoolean(sessionStorage.getItem('autocomplete'));

        sessionStorage.removeItem('autocomplete');

        if (!userObject.UniqueSearch) {
            userObject.UniqueSearch = { Id: crypto.randomUUID(), Keyword: p.Keyword, Page: p.Page, filters: {}, total_results: p.TotalResults };
            setUserObject(userObject);
        }
        if (userObject) {
            p.IsAuthenticated = userObject.IsAuthenticated;
            p.TotalResults = data.Total;
            if (isEmpty(p.Keyword?.toString()) || (userObject.UniqueSearch && p.Keyword?.toLowerCase() === userObject.UniqueSearch.Keyword?.toLowerCase())) {
                p.UniqueSearchID = userObject.UniqueSearch.Id;
                usaj_ga.log_search_filter_interaction(p, isAutocomplete);
            }
            else {
                userObject.UniqueSearch.Id = crypto.randomUUID();
                userObject.UniqueSearch.Keyword = p.Keyword;
                userObject.UniqueSearch.Page = p.Page;
                p.UniqueSearchID = userObject.UniqueSearch.Id;
                setUserObject(userObject);
                usaj_ga.log_search(p, isAutocomplete);
            }
        }
    }

    AddSavedJob(documentID: string) {
        fetch(`/Applicant/Profile/SaveSavedJob?job=${documentID}`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            cache: "no-cache"
        });
    }

    DeleteSavedJob(documentID: string) {
        fetch(`/Applicant/Profile/DeleteSavedJob?job=${documentID}`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            cache: "no-cache",
        });
    }

    async SaveSearch(query: Params, searchName: string, emailFrequency: string): Promise<SavedSearchResult | undefined> {       
        query.SavedSearchName = searchName;
        query.EmailFrequency = emailFrequency;
        const response = await fetch('/Search/Save', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            cache: "no-cache",
            body: JSON.stringify(query)
        });

        if (response.ok) {
            return await response.json();
        }
    }

    async UpdateSearch(query: Params, cansearchID: number): Promise<SavedSearchResult | undefined> {
        query.SavedSearchID = cansearchID;
        const response = await fetch('/Search/Update', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            cache: "no-cache",
            body: JSON.stringify(query)
        });

        if (response.ok) {
            return await response.json();
        }
    }
}



